<template>
  <div
    :class="['top_banner', { active: showTopBanner }]"
    :style="topBannerClose"
    v-if="open"
  >
    <div class="swiper-container topSwiper" ref="topSwiperRef">
      <ul class="swiper-wrapper">
        <li
          :class="[`top_color0${(idx % 3) + 1}`, 'swiper-slide']"
          v-for="(item, idx) in bannerList"
          :key="`top-banner-key-${idx}`"
        >
          <a
            :href="item.link_useyn === 'Y' ? item.link : '#'"
            :target="item.link_blank === 'B' ? '_blank' : '_self'"
            :rel="item.link_blank === 'B' ? 'noreferrer noopener' : ''"
            >{{ item.title }}</a
          >
        </li>
      </ul>
      <div class="swiper_navi">
        <div class="swiper_btn_area">
          <button
            type="button"
            :class="['btn_play', { on: isPlay }]"
            @click="autoToggle"
          >
            play
          </button>
          <button
            type="button"
            :class="['btn_stop', { on: !isPlay && bannerList.length > 1 }]"
            @click="autoToggle"
          >
            stop
          </button>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>

    <p class="banner_ck">
      <input
        type="checkbox"
        id="banner_close_check"
        @change="todayClose"
      /><label for="banner_close_check" class="">오늘하루닫기</label>
    </p>
    <button class="top_close" @click="bannerClose">닫기</button>
  </div>
</template>

<script>
import { get } from 'lodash-es';
import { mapMutations, mapState } from 'vuex';
import Swiper from 'swiper';
import Cookies from 'js-cookie';

/**
 * @module components/pc/TopBanner
 * @desc 티배너
 * @vue-data {Array} bannerList=[]] 배너 리스트 배열
 * @vue-data {Swiper} swiper=null 스와이퍼 인스턴트
 * @vue-data {Boolean} isPlay=false 재생 유무
 * @vue-data {Boolean} today=false 오늘하루닫기 체크 유무
 * @vue-data {Boolean} open=false 숨김 유무
 * @vue-data {Object} topBannerClose={} 최상위 element style 속성
 */
export default {
  data() {
    return {
      bannerList    : [],
      swiper        : null,
      isPlay        : false,
      today         : false,
      open          : false,
      topBannerClose: {}
    };
  },
  computed: {
    ...mapState('main', {
      showTopBanner: 'showTopBanner'
    })
  },
  mounted() {
    this.loadBanner();

    if (Cookies.get('todayClose')) {
      this.setShowTopBanner(false);
    }
  },
  methods: {
    /**
     * 배너 로드
     */
    loadBanner() {
      this.axios('/api/getPopups.do').then((res) => {
        this.bannerList = get(res, 'data.item', []);
        this.open = this.bannerList.length > 0;
        // this.topBannerClose = {
        //   ...this.topBannerClose,
        //   display: 'block'
        // };

        this.$nextTick(() => {
          this.initSwiper();
        });
      });
    },
    /**
     * 스와이퍼 초기화
     */
    initSwiper() {
      if (this.bannerList.length <= 1) {
        return;
      } else {
        if (this.swiper) {
          this.swiper.destroy();
          this.isPlay = false;
        }
      }
      this.swiper = new Swiper(this.$refs.topSwiperRef, {
        loop    : true,
        autoplay: {
          delay               : 4000,
          disableOnInteraction: false
        },
        pagination: {
          el       : this.$refs.topSwiperRef.querySelector('.swiper-pagination'),
          clickable: true
        }
      });
    },
    ...mapMutations('main', {
      setShowTopBanner: 'SET_SHOW_TOP_BANNER'
    }),
    /**
     * 재생 & 정지 버튼 이벤트
     */
    autoToggle: function() {
      var swiper = this.swiper;
      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
        this.isPlay = true;
      } else {
        swiper.autoplay.start();
        this.isPlay = false;
      }
    },
    /**
     * 배너 닫기
     */
    bannerClose: function() {
      if (this.today) {
        Cookies.set('todayClose', true, { expires: 1 });
      }
      this.topBannerClose = {
        ...this.topBannerClose,
        height: 0
      };
      setTimeout(() => {
        this.open = false;
        this.setShowTopBanner(false);
      }, 300);
    },
    /**
     * 오늘하루닫기 체크박스 change 이벤트
     */
    todayClose: function(e) {
      this.today = e.target.checked;
    }
  }
};
</script>

<style lang="scss" scoped></style>
